export const EMPLOYEE_COLOR_POOL = [
  ["#8FBF7F", "#1c3a1c"],
  ["#E8D34D", "#4a4108"],
  ["#D96C5A", "#4a1a10"],
  ["#E3A857", "#4a2f08"],
  ["#7FA8C9", "#122a3d"],
  ["#B490C4", "#33203d"],
  ["#C97FA0", "#3d1526"],
  ["#F0B7C4", "#5c1526"],
  ["#9FCFC4", "#0f332c"],
  ["#C7B08A", "#3a2c10"],
  ["#A9C97F", "#243719"],
  ["#7FC9B0", "#14372d"],
];

const stableHash = (value) => {
  let hash = 0;
  for (const character of String(value))
    hash = (hash * 31 + character.charCodeAt(0)) >>> 0;
  return hash;
};

export function employeeColor(employeeId) {
  if (!employeeId) return { background: "#3E4F6E", foreground: "#ffffff" };
  const [background, foreground] =
    EMPLOYEE_COLOR_POOL[stableHash(employeeId) % EMPLOYEE_COLOR_POOL.length];
  return { background, foreground };
}

export function projectColor(mandatId) {
  if (!mandatId) return { background: "#eef2f6", foreground: "#334155" };
  let hue = 0;
  for (const character of String(mandatId))
    hue = (hue * 31 + character.charCodeAt(0)) % 360;
  return {
    background: `hsl(${hue},42%,88%)`,
    foreground: `hsl(${hue},48%,32%)`,
  };
}
